export const modalContent: CSSFunction = ({ theme }) => ({
  margin: '-24px -14px 0',
  fontFamily: theme.fonts.tvFont,
});
